import {getAbsoluteUrl} from "../../utils/urlUtill";
import {IHttpPromise, IHttpResponse, IHttpService, ILogService, IPromise} from "angular";
import {LoaderStatusValue} from "../../loader/service/loaderStatus";
import {ToastNotificationService} from "../../utils/ToastNotificationService";
import {Customer} from "../../customers/model/Customer";
import {Contact} from "../../contact/model/Contact";
import {UserDto} from "modules/users/model/User";

export class CustomerDetailsService {

    private $http: angular.IHttpService;
    private $log: angular.ILogService;
    private LoaderService: LoaderStatusValue;
    private notificationsService: ToastNotificationService;

    constructor($log: ILogService,
                $http: IHttpService,
                LoaderService: LoaderStatusValue,
                notificationsService: ToastNotificationService) {
        this.$http = $http;
        this.$log = $log;
        this.LoaderService = LoaderService;
        this.notificationsService = notificationsService;
    }

    changeCustomerNewsSubscriptionStatus = (selectedContactId: number,
                                            subscribedForNews: boolean) =>
        this.$http({
            method: 'PUT',
            url: getAbsoluteUrl('api/customer'),
            params: {inToMarketingCampaign: subscribedForNews},
            data: {
                customerId: selectedContactId,
                status: subscribedForNews
            }
        });

    restoreCustomer = (customerId) =>
        this.$http({method: 'GET', url: getAbsoluteUrl('customer/restore/' + customerId)})
            .then((resp) => {
                    this.LoaderService.off();
                    this.notificationsService.generateSuccessMessage("Contact was restored.");
                    return resp;
                }
                , () => {
                    this.LoaderService.off();
                    this.notificationsService.generateErrorMessage("Contact wasn't restored");
                }
            );

    getCustomerLoanInfo = (customerId) => this.$http({
        method: 'GET',
        url: getAbsoluteUrl(`api/customer/${customerId}/loan_info`)
    });

    getCustomerCalculationLog = (customerId, page, pageSize) => this.$http({
        method: 'GET',
        url: getAbsoluteUrl(`api/calculations/execution/customer/${customerId}`, {
            page: page,
            pageSize: pageSize
        })
    });

    changeCustomerCalculationsStatus = (customerId, configuration) =>
        this.$http({
            method: 'PUT',
            url: getAbsoluteUrl(`customer/${customerId}/calculation/status`),
            data: configuration
        });

    updateContact = <T extends Contact> (customer: T) => this.$http({
        method: 'PUT',
        url: getAbsoluteUrl('contact'),
        data: customer,
        params: {
            type: customer.type
        }
    }).then((resp) => {
        if (resp.status == 200) {
            this.notificationsService.generateSuccessMessage("Contact was updated.");
        } else {
            this.notificationsService.generateErrorMessage("Contact wasn't updated")
        }
        return resp;
    }, () => {
        this.notificationsService.generateErrorMessage("Contact wasn't updated")
    });

    getCustomerDetail = (customerId) : IHttpPromise<Customer> => {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('customer/' + customerId)
        });
    };

    getCustomerCoborrowers = (customerId, callback, error) => {
        this.$http({method: 'GET', url: getAbsoluteUrl(`customer/${customerId}/coborrowers/`)})
            .then(callback, error)
    };

    makeContactAvailableForUpdate = (customerId): IPromise<IHttpResponse<any>> =>
        this.$http({
            method: 'GET',
            url: getAbsoluteUrl('customer/last-update/' + customerId)
        }).then(
            (resp) => {
                this.notificationsService.generateSuccessMessage("Contact was updated.");
                return resp;
            },
            (err) => {
                this.notificationsService.generateErrorMessage("Contact wasn't updated")
                return err;
            }
        );

    saveNewFunnelStatus = (newFunnelStatus) => this.$http({
        method: 'POST',
        url: getAbsoluteUrl('funnel-status/create'),
        headers: {'Content-Type': 'application/json'},
        data: newFunnelStatus
    }).then(
        (resp) => {
            this.notificationsService.generateSuccessMessage("Funnel status was added.");
            return resp;
        },
        () => this.notificationsService.generateErrorMessage("Funnel status was't added.")
    );

    saveNewLeadStatus = (newLeadStatus) => this.$http({
        method: 'POST',
        url: getAbsoluteUrl('lead-status/create'),
        headers: {'Content-Type': 'application/json'},
        data: newLeadStatus
    }).then(
        (resp) => {
            this.notificationsService.generateSuccessMessage("Lead status was added.");
            return resp;
        },
        () => this.notificationsService.generateErrorMessage("Lead status was't added.")
    );

    generateNewFunnelStatus = function (customerId) {
        return {funnelStatus: '', created: new Date(), customerId: customerId}
    };

    generateNewLeadStatus = function (customerId) {
        return {leadStatus: '', created: new Date(), customerId: customerId}
    };

    updateFunnelStatus = (funnelStatus) => this.$http({
        method: 'PUT',
        url: getAbsoluteUrl('funnel-status/update'),
        headers: {'Content-Type': 'application/json'},
        data: funnelStatus
    }).then((resp) => {
        this.notificationsService.generateSuccessMessage("Funnel status was updated");
        return resp;
    }, () => this.notificationsService.generateErrorMessage("Funnel status was't updated"));

    updateLeadStatus = (leadStatus) => this.$http({
        method: 'PUT',
        url: getAbsoluteUrl('lead-status/update'),
        headers: {'Content-Type': 'application/json'},
        data: leadStatus
    }).then((resp) => {
        this.notificationsService.generateSuccessMessage("Lead status was updated");
        return resp;
    }, () => this.notificationsService.generateErrorMessage("Lead status was't updated"));

    findCustomerCalculationsConfiguration = (customerId) => this.$http({
        method: 'GET',
        url: getAbsoluteUrl(`customer/${customerId}/calculations/configuration`)
    })

    queryEmployee = (query: string): IHttpPromise<UserDto[]> => {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('api/code'),
            params: {query}
        })
    };

}
